import React from "react";
import OpenInNew from "@material-ui/icons/OpenInNew";

export interface Props {
  href: string;
}

export const ExternalLink: React.FC<Props> = ({ href }): JSX.Element => {
  return (
    <p style={{ display: "inline" }}>
      <a href={href} target="_blank">
        <OpenInNew />
      </a>
    </p>
  );
};
